import { ref, provide, inject } from '@vue/composition-api'

const toastSymbol = Symbol('toast_queue')

class ToastMessageQueue {
  constructor () {
    this.queue = ref([])
  }

  addMessage (message) {
    this.queue.value.push(new Message(message, this))
  }
}

class Message {
  constructor (message, toastMessageQueue) {
    this._message = message
    this.id = Date.now()
    this.timer_started = false
    this.toastMessageQueue = toastMessageQueue
  }

  get message () {
    if (!this.timer_started) {
      setTimeout((thisMessage) => {
        thisMessage.toastMessageQueue.queue.value = thisMessage.toastMessageQueue.queue.value.filter((message) => message !== thisMessage)
      }, 3000, this)
    }
    return this._message
  }

  set message (value) {
    this._message = value
  }
}

export function provideToastMessageQueue () {
  provide(toastSymbol, new ToastMessageQueue())
}

export function injectToastMessageQueue () {
  const toast = inject(toastSymbol)
  if (!toast) throw new Error('No toast queue provided')
  return toast
}
